<template>
	<ModalFormCard class='lg:min-w-[800px] modal-default'
		:action='"/actions/subscription-reactivate/"+subscription.id'
	>
		<template #title>Reactivate subscription</template>

		<template #default='{ saving, errors }'>
			<p class='font-semibold text-17'>Canceled subscription</p>

			<SubscriptionBreakdown
				class='mt-6'
				:plan='subscription.plan'
				:industry='subscription.company.industry'
				:area='subscription.location_area'
				:productId='subscription.product_id'
			/>

			<Select selectClass='!bg-grey text-15' class='mt-4'
				menuClass='!bg-grey' name='reason' 
				label='Reactivation reason' placeholder='Select a reason' 
				v-model:value='value.reason' 
				:disabled='saving'
				:options='reasons.map(r => {
					return { html: r, value: r }
				})'
			/>

			<InputCheckbox name='terms' class='mt-4'>
                <p class='text-grey-900 text-14 pl-2'>I agree to Zapo’s <a href='https://www.zapo.com/privacy-policy' target='_blank' class='underline'>Privacy Policy</a> and <a href='https://www.zapo.com/terms-and-conditions' target='_blank' class='underline'>Terms</a></p>
            </InputCheckbox>

			<div class='pt-6'>
		    	<ButtonSaving class='button-black h-12 px-6' :disabled='saving'>
		    		Reactivate subscription
		    	</ButtonSaving>
		    </div>
		</template>
	</ModalFormCard>
</template>

<script>
	import Subscription from '~/models/subscription.js';
	import PaymentMethod from '~/models/payment-method.js';
	import Modal from '~/mixins/modal.js'
	import SubscriptionBreakdown from '~/components/customer/blocks/subscription-breakdown-inline.vue'

	export default {
		mixins: [Modal],

		data() {
			return {
				reasons: [
					"I made a huge mistake and i want to come back"
				],
				value: {
					reason: null
				}
			}
		},
	
		computed: {
			subscription() {
				return this.editingModel
			}
		},

		components: {
			SubscriptionBreakdown
		}
	}
</script>
